import { Fragment } from "react/jsx-runtime";
import { Card, Col } from "reactstrap";
import { H5, Image, LI, P, UL } from "../../../../AbstractElements";
import { LearningGridData } from "../../../../Data/Miscellaneous/Learning";
import { dynamicImage } from "../../../../Utils";

const BlogBoxGrid = () => {
  return (
    <Fragment>
      {LearningGridData.map((item) => (
        <Col xl="4" sm="6" className="xl-50 box-col-6" key={item.id}>
          <Card>
            <div className="blog-box blog-grid text-center product-box">
              <div className="product-img">
                <Image className="img-fluid top-radius-blog" src={dynamicImage(`faq/${item.src}`)} alt="" />
                <div className="product-hover">
                  <UL className="simple-list flex-row">
                    <LI><i className="icon-link"></i></LI>
                    <LI><i className="icon-import"></i></LI>
                  </UL>
                </div>
              </div>
              <div className="blog-details-main">
                <UL className="blog-social simple-list flex-row justify-content-center">
                  <LI>{item.date}</LI>
                  <LI>{"by: Admin"}</LI>
                  <LI>{"0 Hits"}</LI>
                </UL>
                <hr />
                <H5>{item.title}</H5>
                <P className="blog-bottom-details">{item.content}</P>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};
export default BlogBoxGrid;
